import { render } from "./TemplatePage.vue?vue&type=template&id=59e9efa9&lang=html"
import script from "./TemplatePage.vue?vue&type=script&lang=js"
export * from "./TemplatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__